import './css/vendor.min.css';
import './css/style.css';
import './css/media.css';
import './App.css';
import HomePage from './Components/Homepage/HomePage';
import { Redirect, Route, Switch } from 'react-router-dom';
import AboutUs from './Components/AboutUs/AboutUs';
import Privacy from './Components/Privacy/Privacy';
import React from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import ContactUs from './Components/ContactUs/ContactUs';
import TermsCondition from './Components/TermsCondition/TermsCondition';
import Faq from './Components/Faq/Faq';
import Course from './Components/CoursePage/Course';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import store from './store';
import PaymentResponse from './Components/Payment-response';
function App() {
  return (
    <Provider store={store}>
    <HelmetProvider >
        <Header/>
        <Switch >
          <Route exact path='/' component={HomePage} />
          <Route exact path='/about-me' component={AboutUs} />
          <Route exact path='/privacy-policy' component={Privacy} />
          <Route exact path='/contact-us' component={ContactUs} />
          <Route exact path='/terms-conditions' component={TermsCondition} />
          <Route exact path='/faq' component={Faq} />
          <Route exact path='/course' component={Course} />
          <Route exact path='/payment/:status' component={PaymentResponse} />
          <Redirect to="/" />
        </Switch>
        <Footer/>
       </HelmetProvider>
   </Provider>
  );
}

export default App;
